import {registerMessageCommon, localizedMessage} from 'epic-react-common/src/components/MessageCommon';
import LocalizationStore from '../../stores/LocalizationStore';

export {localizedMessage};

export default registerMessageCommon(LocalizationStore);
